import React, { Component } from 'react'
import PT from 'prop-types'
import { withRouter } from 'react-router-dom'
import cx from 'classnames'
import Logo from './Logo/Logo'
import Menu from './Menu'
import Fb from './Fb'
import Ig from './Ig'
import './Header.css'
import './StickyHeader.css'
import ThanksRtvs from './ThanksRtvs'

class Header extends Component {
  state = { menuOpened: false, isScrolled: false }

  componentDidMount() {
    window.addEventListener('scroll', this.closeMenu)
    window.addEventListener('scroll', this.affix)
  }

  componentDidUpdate(prevProps) {
    const urlChanged = prevProps.location.pathname !== this.props.location.pathname
    if (urlChanged) {
      this.closeMenu()
    }
  }

  handleMenuToggle = (e) => {
    e.preventDefault()

    if (this.state.menuOpened) {
      this.closeMenu()
    } else {
      this.openMenu()
    }
  }

  affix = () => {
    const { scrollY } = window
    const { isScrolled } = this.state

    if (scrollY > 4 && !isScrolled) {
      this.setState({ isScrolled: true })
    }

    if (scrollY <= 4 && isScrolled) {
      this.setState({ isScrolled: false })
    }
  }

  openMenu() {
    document.querySelector('html').classList.add('menu-opened')
    this.setState({ menuOpened: true })
  }

  closeMenu = () => {
    if (!this.state.menuOpened) return

    document.querySelector('html').classList.remove('menu-opened')
    this.setState({ menuOpened: false })
  }

  render() {
    const is89 = this.props.location.pathname.startsWith('/89')

    return (
      <header className={cx({ affixed: this.state.isScrolled, is89 })}>
        <div className="header-content">
          <Logo />
          <a href="" className="burger" onClick={this.handleMenuToggle}>Menu</a>
          <nav>
            <Menu />
            <div className="icons">
              <Fb />
              <Ig />
            </div>
          </nav>
        </div>
      </header>
    )
  }
}

Header.propTypes = {
  location: PT.shape({
    pathname: PT.string.isRequired,
  }).isRequired,
}

export default withRouter(Header)



// WEBPACK FOOTER //
// ./src/components/Header/Header.js